<nav class="detail-nav" *ngIf="slug">
  <a routerLinkActive="active" [routerLink]="tabLink('overview')">Overview</a>
  <a routerLinkActive="active" [routerLink]="tabLink('skills')">Skills &amp; Resources</a>
  <a routerLinkActive="active" [routerLink]="tabLink('evidence-modes')">Evidence Modes</a>
  <a routerLinkActive="active" [routerLink]="tabLink('graph')">Graph</a>
  <a routerLinkActive="active" [routerLink]="tabLink('resources')">Revalidate Resources</a>
</nav>

<router-outlet></router-outlet>
